// extracted by mini-css-extract-plugin
export default {"fs":"ca1141a4b6 c1e598772e"};